// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import JS
import "../css/index.css";
import menuOpen from "./menuOpen";
import "@mux/mux-player";

menuOpen();
